import React from 'react';

const AppliedFilters = ({
  appliedFilters,
  setAppliedFilters,
  SetLastFilterSelect,
  shopifyObj
}) => {
  const handleRemoveFilter = filterToRemove => {
    const newfilters = appliedFilters.filter(
      each =>
        each.name != filterToRemove.name || each.value != filterToRemove.value
    );
    // updateCategoryWiseFilters(newfilters);
    // console.log(filterToRemove.name,'fil remove')
    SetLastFilterSelect(filterToRemove.name);
    setAppliedFilters(newfilters); 
    if (newfilters.length === 0) {
      localStorage.removeItem(shopifyObj.collectionHandle);
      console.log(localStorage,'localStorage')
    } else {
      localStorage.setItem(
        shopifyObj.collectionHandle,
        JSON.stringify(newfilters)
      );
    }
    // localStorage.removeItem(shopifyObj.collectionHandle);
  };

  return (
    <div className="applied-filter">
      <div>
        {appliedFilters &&
          appliedFilters.map(filter => {
            return (
              <label key={filter.value} className="applied-filter-label">
                <span>{filter.displayName}</span>
                <span onClick={() => handleRemoveFilter(filter)}>
                  {filter.value}{' '}
                  <em
                    style={{ fontStyle: 'inherit' }}
                    className={'closefilter-fill'}
                  >
                    X
                  </em>{' '}
                </span>
              </label>
            );
          })}
      </div>
      <div className="applied-filters-clear">
        {appliedFilters && appliedFilters.length > 0 && (
          <a id="clear-filters" onClick={() => setAppliedFilters([])}>
            Clear Filters
          </a>
        )}
      </div>
    </div>
  );
};

export default AppliedFilters;
